var _defs, _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisgusted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "base",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.02 314.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-3,\n      .cls-4 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n      .cls-1,\n      .cls-4 {\n        stroke: #3d3327;\n      }\n      .cls-1 {\n        stroke-width: 14px;\n      }\n      .cls-2 {\n        fill: #ff7bac;\n      }\n      .cls-3 {\n        stroke: #5d3233;\n        stroke-width: 20px;\n      }\n      .cls-4 {\n        stroke-width: 3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.4,239.64s49.86-41.43,120.18,1.33",
    transform: "translate(-218.56 -214.62)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.56,241.16s51.68-39.14,120,6.76",
    transform: "translate(-218.56 -214.62)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.14,476.05S360.09,549.5,418.39,510,365.14,476.05,365.14,476.05Z",
    transform: "translate(-218.56 -214.62)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.38,491.24c116.15-53.2,204,28.32,204,28.32",
    transform: "translate(-218.56 -214.62)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248,461",
    transform: "translate(-218.56 -214.62)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M415,229s-2.19,27.88,19.4,29.44",
    transform: "translate(-218.56 -214.62)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.5,236.5s10,14.41,0,27.7",
    transform: "translate(-218.56 -214.62)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisgusted);
export default __webpack_public_path__ + "static/media/disgusted.c901a12b.svg";
export { ForwardRef as ReactComponent };